import "./Card.css";

const Card = ({ children, className = "", hoverEffect = true }) => {
	return (
		<div className={`card ${className} ${hoverEffect ? "hover-effect" : ""}`}>
			{children}
		</div>
	);
};

export default Card;
